// Entry ligero para landings de campaña: conversión completa, CERO 3D.
// El chunk three/gsap nunca se descarga en estas páginas.
import { initReveals } from './ui/reveals'
import { initConversion } from './ui/conversion'
import { initCalModal } from './ui/calmodal'
import { initMenu } from './ui/menu'
import { captureGclid } from './analytics/gclid'
import { initMarqueeModal } from './ui/marqueeModal'
import { initLeadCotizacion } from './ui/leadCotizacion'

document.documentElement.classList.add('js')

captureGclid()
initReveals()
initMarqueeModal() // ficha al hover/tap sobre las marcas del marquee (solo /resultados/)
initConversion()
initLeadCotizacion() // form de lead cotización (solo /sitios-web/inversion/)
initMenu() // antes del CalModal: su CTA inyectado también debe interceptarse
initCalModal()
